import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  logoWrapper: {
    position: 'relative',
    display: 'inline-block',
    width: 'fit-content',
    verticalAlign: 'middle',
    lineHeight: 0,
  },
  baseSvg: {
    position: 'relative',
    display: 'block',
  },
}));

export default useStyles;
